import Global from "@/utils/Global";
import Tools from "@/utils/Tools";

export type InputLogin = {
  userName: string;
  password: string;
};

/**
 * 登录账号
 */
export function fetchLoginAsync(input: InputLogin) {
  return Tools.FetchAsync<{
    token: string;
    refreshToken: string;
  }>("/Auth/Login", input, "POST", "application/json", false);
}

/**
 * 尝试Token自动登录
 */
export function fetchLoginFromTokenAsync(token: string) {
  return Tools.FetchAsync<
    {
      token: string;
      refreshToken: string;
    }>(`/Auth/LoginFromToken`, {
      token
    }, "GET");
}

/**
 * 执行刷新登录
 * @param input
 */
export function RefreshTokenAsync() {
  return Tools.FetchAsync<{
    token: string;
    refreshToken: string;
  }>(
    "/Auth/RefreshToken",
    {
      refreshToken: Global.RefreshToken,
    },
    "POST",
    "application/json",
    false
  );
}

export type InputRegister = {
  /**
   * 邮件
   */
  Email: string;
  /**
   * 手机号码
   */
  Phone: string,
  /**
   * 密码
   */
  Password: string;
  /*
   * 邮箱验证码
   */
  EmailCode: string;
  /**
   * 父账号Uid
   */
  ParentAccountUid: string;
};

export type InputResetPassword = {
  Email: string;
  EmailCode: string;
  Password: string;
};

/**
 * 注册
 */
export async function fetchRegisterAsync(input: InputRegister) {

  //#region 检查是否存在上级标识符

  if (Tools.IsNull(input.ParentAccountUid)) {
    const EXCHANGE_SHARE_UID = Tools.GetLocalStorage('EXCHANGE_SHARE_UID', "");
    if (Tools.IsNotNull(EXCHANGE_SHARE_UID)) {
      input.ParentAccountUid = EXCHANGE_SHARE_UID;
    }
  }
  
  //#endregion

  const resp = await Tools.FetchAsync<{
    token: string;
    refreshToken: string;
  }>("/Auth/Register", input, "POST", "application/json", false);

  if (resp.CheckIsOk(false))
    Tools.RemoveLocalStorage("EXCHANGE_SHARE_UID");

  return resp;
}

/**
 * 重置密码
 */
export function fetchResetPassword(input: InputResetPassword) {
  return Tools.FetchAsync("/Auth/ResetPassword", input, "POST");
}
